import { useState } from "react";
import styles from "~/styles/burn-rate.module.css";

interface Segment {
  label: string;
  value: number;
  color: string;
}

interface DonutChartProps {
  segments: Segment[];
  sym: string;
  total: number;
}

export function DonutChart({ segments, sym, total }: DonutChartProps) {
  const [hovered, setHovered] = useState<number | null>(null);
  const size = 140;
  const stroke = 14;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;

  const validSegments = segments.filter((s) => s.value > 0);
  const totalValue = validSegments.reduce((sum, s) => sum + s.value, 0) || 1;

  let offset = 0;

  return (
    <div className={styles.chartCard}>
      <p className={styles.chartTitle}>Composición</p>
      <div className={styles.donutWrap}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className={styles.donutSvg}>
          {validSegments.map((seg, i) => {
            const pct = seg.value / totalValue;
            const dash = pct * c;
            const style = {
              strokeDasharray: `${dash} ${c - dash}`,
              strokeDashoffset: -offset,
              opacity: hovered === null || hovered === i ? 1 : 0.35,
              transition: "opacity 0.2s, stroke-width 0.2s",
            };
            offset += dash;
            return (
              <circle
                key={i}
                cx={size / 2}
                cy={size / 2}
                r={r}
                fill="none"
                stroke={seg.color}
                strokeWidth={hovered === i ? stroke + 3 : stroke}
                strokeLinecap="round"
                style={style}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                onTouchStart={() => setHovered(i)}
              />
            );
          })}
        </svg>
        <div className={styles.donutCenter}>
          <span className={styles.donutSym}>{sym}</span>
          <span className={styles.donutTotal}>{total.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
        </div>
      </div>
      <div className={styles.donutLegend}>
        {validSegments.map((seg, i) => (
          <button
            key={i}
            className={`${styles.legendItem} ${hovered === i ? styles.legendItemActive : ""}`}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}
            onTouchStart={() => setHovered(i)}
          >
            <span className={styles.legendDot} style={{ background: seg.color }} />
            <span className={styles.legendLabel}>{seg.label}</span>
            <span className={styles.legendValue}>{sym}{seg.value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
          </button>
        ))}
      </div>
    </div>
  );
}
